import React from 'react'
import ReactModal from 'react-modal'
import { useDispatch } from 'react-redux'
import { Capacitor } from '@capacitor/core'

import { closeModal } from 'store/actions/modals'
import { Button as MerinioButton, List } from 'ui'

import { t } from 'translations'

// Bind the modal to the root element
if (!process.env.IS_TEST) {
  ReactModal.setAppElement('#root')
}

const BaseModalActions = ({ children }) => {
  const dispatch = useDispatch()

  return (
    <ReactModal
      isOpen
      className="merinio-actions-modal"
      overlayClassName={`merinio-modal-overlay${Capacitor.isNativePlatform() ? ' is-mobile-app' : ''}`}
      shouldFocusAfterRender
      // These two lines are required to allow closing when the user clicks outside of the modal
      onRequestClose={() => dispatch(closeModal())}
      shouldCloseOnOverlayClick
    >
      {children}

      {/* Close button */}
      <List>
        <MerinioButton
          className="list-group-item list-group-item-action list-group-flush"
          onClick={() => {
            dispatch(closeModal())
          }}
        >
          <i className="far fa-times mr-2" />
          {t('actions.CLOSE')}
        </MerinioButton>
      </List>
    </ReactModal>
  )
}

export default BaseModalActions
